import {
  REQUEST_NOTICE_LIST_FOR_MAIN_PAGE,
  REQUEST_NOTICE_LIST,
  REQUEST_NOTICE_DTL
} from './mutation-types';
  
import axiosInst from '@/utility/axiosInst';
  
export default {
  
  requestNoticeListForMainPage({commit}) {
    return axiosInst.springAxiosInst.get("/notice/getMainPageList")
      .then((res) => {
        commit(REQUEST_NOTICE_LIST_FOR_MAIN_PAGE, res.data)
      })
      .catch(err => {
        console.error('error: ', err)
      })
  },

  requestNoticeList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get("/notice/get-list", {
      params: {
        page: currentPage,
        searchType: searchType,
        searchWord : searchWord
      }
    }).then((res) => {
      commit(REQUEST_NOTICE_LIST, res.data)
    })
  },

  requestNoticeDtl({commit}, noticeSeq) {
    return axiosInst.springAxiosInst.get("/notice/get-detail", {
      params: {
        noticeSeq: noticeSeq
      }
    }).then((res) => {
      commit(REQUEST_NOTICE_DTL, res.data)
    })
  }
}